import React, { useCallback } from "react";
import { Button, Flex, Text } from "@jsq/ds/core";
import {
  AUDIT_LOG_SUMMARY_PREVIEW_LIMIT,
  ComplianceActivityCardBody,
} from "../ComplianceActivityCard";
import { ComplianceStatusCardBody } from "../ComplianceStatusCard";
import * as styles from "./styles_vanilla.css";

export const ComplianceGPSummaryCard: React.FC<{ arenaId: number; arenaName: string }> = ({
  arenaId,
  arenaName,
}) => {
  const goToCompliance = useCallback(() => {
    window.location.assign("/compliance");
  }, []);

  return (
    <Flex className={styles.shelf}>
      <Flex className={styles.statusHeader}>
        <Flex className={styles.statusTitleGroup}>
          <Text variant="h3">AML/KYC status</Text>
          <Text variant="regular-sm" className={styles.sectionSubtitle}>
            All investment entities with compliance enabled
          </Text>
        </Flex>
        <Button
          displayAsLink
          isInline
          type="button"
          className={styles.viewAllButton}
          onClick={goToCompliance}
        >
          View compliance dashboard
        </Button>
      </Flex>
      <ComplianceStatusCardBody arenaId={arenaId} legendPlacement="right" />
      <div className={styles.sectionDivider} aria-hidden />
      <ComplianceActivityCardBody
        arenaId={arenaId}
        arenaName={arenaName}
        maxVisibleItems={AUDIT_LOG_SUMMARY_PREVIEW_LIMIT}
      />
    </Flex>
  );
};
